import { Accordion, Paragraph } from '@cheapreats/react-ui';
import * as React from 'react';
export default {
  Accordion,
  Paragraph,
  React
};